module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/big/6-f99ee49ea2ec1474b05c6c67f20d1753.webp";